function setPersistentCartCookie() {
  Shopify.setCookie('persistent-cart', nalaPersistentCart.hash, 365);
}

function initPersistentCart() {
  if (!nalaPersistentCart.active) {
    return;
  }
  var customerId = nalaPersistentCart.customer;
  var hash = nalaPersistentCart.hash;
  var pCartCookie = Shopify.getCookie('persistent-cart');

  if (pCartCookie != hash && customerId) {
    addPersistentCart();
  } else if (pCartCookie != hash) {
    removePersistentCart();
  } else if (customerId) {
    //getPersistentCartDiff();
  }
}

function removePersistentCart() {
  if (!nalaPersistentCart.active) {
    return;
  }
  axios
    .post('/cart/clear.js')
    .then(() => {
      setPersistentCartCookie();
      triggerCartUpdate();
    })
    .catch((e) => {
      console.log('removePersistentCart error', e);
    });
}

function addPersistentCart() {
  if (!nalaPersistentCart.active) {
    return;
  }

  axios
    .get(
      `/apps/nala-persistent-cart/cart/${nalaPersistentCart.customer}/${nalaPersistentCart.hash}`
    )
    .then((response) => {
      setPersistentCartCookie();

      if (response.data.count > 0) {
        const cart_items = response.data.items.map((item) => {
          return {
            id: item.id,
            quantity: item.quantity,
            properties: Array.isArray(item.properties) ? {} : item.properties,
            selling_plan: item?.selling_plan || "",
          };
        });

        const data = {
          items: cart_items,
        };

        axios
          .post('/cart/add.js', data)
          .then(() => {
            triggerCartUpdate();
          })
          .catch((e) => {
            console.log('add to cart error:', e);
          });
      }
    })
    .catch((e) => {
      console.log('addPersistentCart error:', e);
    });
}

function updatePersistentCart() {
  if (!nalaPersistentCart.active || !nalaPersistentCart.customer) {
    return;
  }

  let checkoutBtn = document.querySelector(".cart__checkout-button");
  if (checkoutBtn) {
    checkoutBtn.disabled = true;
  }

  const cart = Alpine.store('state').cart;
  const data = {
    items: cart.items,
    carttoken: cart.token,
  };

  axios
    .post(
      `/apps/nala-persistent-cart/update/${nalaPersistentCart.customer}/${nalaPersistentCart.hash}`,
      data
    )
    .then(() => {})
    .catch((e) => {
      console.log('error', e);
    })
    .then(() => {
      if (checkoutBtn) {
        checkoutBtn.disabled = false;
      }
    });
}

function getPersistentCartDiff() {
  if (!nalaPersistentCart.active) {
    return;
  }

  const cart = Alpine.store('state').cart;
  const data = {
    items: cart.items,
    carttoken: cart.token,
  };

  axios
    .post(
      `/apps/nala-persistent-cart/diff/${nalaPersistentCart.customer}/${nalaPersistentCart.hash}`,
      data
    )
    .then((response) => {
      if (response.data.enabled === 0) {
        axios.post('/cart/clear.js');
      } else if (response.data.count > 0) {
        axios.post('/cart/clear.js').then(() => {
          const cart_items = response.data.items.map((item) => {
            return {
              id: item.id,
              quantity: item.quantity,
              properties: Array.isArray(item.properties) ? {} : item.properties,
            };
          });

          const data = {
            items: cart_items,
          };

          axios.post('/cart/add.js', data).then(() => {
            triggerCartUpdate();
          });
        });
      }
    })
    .catch((e) => {
      console.log('error', e);
    });
}